<template>
  <SweetModal
    ref="modal"
    :hide-close-button="true"
    :blocking="true"
    overlay-theme="dark"
  >
    <div class="text-center mt-4">
      <i class="fas fa-sync-alt fa-spin fa-5x"/>
    </div>

    <div v-html="loadingMessage" class="my-4 text-center"></div>
  </SweetModal>

</template>

<script>
import { SweetModal } from 'sweet-modal-vue'
import { mapState } from 'vuex'

export default {
  name: 'LoadingDialog',
  components: { SweetModal },
  computed: {
    ...mapState('dialogs', ['loadingMessage', 'isLoadingOpen'])
  },
  watch: {
    isLoadingOpen (open) {
      if (open) {
        this.$refs.modal.open()
      } else {
        this.$refs.modal.close()
      }
    }
  }
}
</script>
